import { IRules } from '../css/CssRules.Contract';
import { MediumDisplayWidth } from '../size/Size.Constants';
import layoutStyles from './VbUiSidebarLayout.Component.module.less';
import sidebarStyles from './VbUiSidebar.Component.module.less';

const sidebarButtonHeight = '48px';

//Css media queries don't allow vars
export function getMobileSidebarLayoutStyles(breakpoint: number): IRules {
	return {
		[`@media (max-width: ${breakpoint || MediumDisplayWidth - 1}px)`]: {
			[`.${layoutStyles.root}`]: {
				'flex-direction': 'column'
			},
			[`.${layoutStyles.mainContentSlot} [slot='mainContent']`]: {
				position: 'absolute',
				top: 0,
				right:0,
				bottom:0,
				left: 0,
				overflow: 'hidden'
			}
		}
	};
}

export function getMobileSidebarStyles(breakpoint: number): IRules {
	return {
		[`@media (max-width: ${breakpoint || MediumDisplayWidth - 1}px)`]: {
			[`.${sidebarStyles.root}`]: {
				'flex-direction': 'column'
			},

			[`.${sidebarStyles.fixedMobileScroll} .${sidebarStyles.sidebarButtonContainer}`]: {
				position: 'fixed',
				bottom: 0
			},

			[`.${sidebarStyles.header}`]: {
				width: '100%'
			},

			'.vbUiSidebarRootOpen': {
				flex: '100%'
			},

			[`.${sidebarStyles.sidebarButton}`]: {
				'border-bottom': 'transparent',
				width: sidebarButtonHeight,
				height: sidebarButtonHeight
			},

			[`.${sidebarStyles.sidebarButtonContainer} [slot=sidebarButtons]`]: {
				'border-left': 'transparent',
				display: 'flex',
				flex: '0 0 auto',
				'justify-content': 'space-around',
				width: '100%',
				'border-top-width': '1px',
				'border-top-style': 'solid'
			},

			[`.${sidebarStyles.sidebarPanel}`]: {
				width: '100%',
				transition: 'none',
				border: 0
			},

			[`.${sidebarStyles.sidebarPanel}:not(.open)`]: {
				height: 0
			},

			[`.${sidebarStyles.sidebarPanelLayout}`]: {
				width: '100%'
			},

			[`.${sidebarStyles.sidebarPanelBody}`]: {
				'margin-bottom': sidebarButtonHeight
			},

			[`.${sidebarStyles.sidebarButtonContainer}`]: {
				width: '100% !important',
				height: 'auto',
				'border-top-width': '1px',
				'border-top-style': 'solid',
				'border-left-width': '0 !important'
			},
			[`.${sidebarStyles.sidebarButtons}`]: {
				'overflow-x': 'auto',
				position: 'static'
			},
			[`.${sidebarStyles.tooltipContainer}.tooltip`]: {
				display: 'block !important'
			},
			[`.${sidebarStyles.sidebarButtons} .btn-label`]: {
				display: `none !important`
			}
		}
	};
}
